import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

type SetSessionLiveStatePayload = {
  sessionUuid: string;
  isLive: boolean;
  liveStartAtMilliSec: number | null;
};

const setSessionLiveStateReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<SetSessionLiveStatePayload>) => {
    state.liveSessionUuid = action.payload.sessionUuid;
    state.isSessionLive = action.payload.isLive;
    state.sessionLiveStartAtMilliSec = action.payload.liveStartAtMilliSec;
    state.liveStateRequestId = undefined;
  });
};

export default setSessionLiveStateReducer;
